import styled, { css } from 'styled-components';
import { CardFooterProps } from './CardFooter';

export const Element = styled.div<CardFooterProps>`
  ${({ theme, ...props }) => {
    return css`
      display: flex;
      justify-content: space-between;
      gap: ${theme.spacing.base};
      padding: ${theme.spacing.base};

      margin-top: auto;

      // border top
      border-top: ${theme.border.base_neutral_400};
    `;
  }};
`;
